import React from "react"
import { PartListItem } from "./ProductItem"
import { explodedViewProductListStyle } from "./style"
import { ExplodedPart } from "../types"

type PartListProps = {
	selectedHotspot: string
	onSetSelectedHotspot: (partNumber: string) => void
	onAddToCart: (partId: string) => void
	parts: ExplodedPart[]
}

export const PartList: React.FC<PartListProps> = ({
	selectedHotspot,
	onSetSelectedHotspot,
	onAddToCart,
	parts = [],
}) => {
	return (
		<section css={explodedViewProductListStyle}>
			{parts.map((part: ExplodedPart, idx: number) => (
				<PartListItem
					key={part.partNumber}
					isActive={part.partNumber === selectedHotspot}
					item={part}
					idx={idx}
					onSetSelectedHotspot={onSetSelectedHotspot}
					onAddToCart={onAddToCart}
				/>
			))}
		</section>
	)
}
